import React from 'react'

import videoService from '../../services/shared.video.service'
import PublicLayout from '../../layout/PublicLayout'
import SharedLoginModal from "../../commons/SharedLoginModal";

class SharedVideoView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            posterUri: null,
            videoUri: null,
            error: null,
            showLoginModal: true,
            token: null,

        }

    }

    componentDidMount() {
        console.log("location:", this.props.location.pathname);
        const pathname = this.props.location.pathname;
        const idx = pathname.lastIndexOf('/');
        const token = pathname.substr(idx + 1);
        console.log("token:", token);
        this.setState({token: token})
        this.loadVideo(token)
    }

    loadVideo = (token, jwt) =>{
        videoService.getVideo(token, jwt).then( video => {
            const posterUri =`/api/v1/share/video/image/medium/${video.fileId}?token=${token}`
            const videoUri = `/api/v1/share/videos/mp4/${video.fileId}?token=${token}`
            this.setState( { posterUri: posterUri, videoUri: videoUri})
        }).
        catch( error => {
            this.setState({error: error})
        })
    }

    login = (username, password) => {
        videoService.login(username, password)
            .then( rsp => {
                console.log('login rsp:', rsp)
                this.setState({showLoginModal: false, error: null})
                this.loadVideo(this.state.token, rsp.jwt)
            })
            .catch(err =>{
                this.setState({error: err, showLoginModal: false})
            })
    }

    render() {

        if ( this.state.error && this.state.error.message === "401"){
            return (
                <PublicLayout>
                    <SharedLoginModal visible={this.state.showLoginModal} onSubmit={this.login} onCancel={() => {
                        this.setState({showLoginModal: false})
                    }}/>
                </PublicLayout>
            )
        }
        if ( !this.state.videoUri || !this.state.posterUri){
            return (<div/>)
        }

        return (

            <PublicLayout>
                <div id="videoContainer" style={{flex: '1 1 auto', margin: 'auto', padding: '32px'}}>

                    <video height="560" width="898" controls poster={this.state.posterUri}
                           preload="none">
                        <source src={this.state.videoUri} type="video/mp4"/>
                    </video>
                </div>
            </PublicLayout>
        )

    }
}

export default SharedVideoView;
